import { createContext } from 'react'

import { IPopupContentData } from 'core-components/library/popup/interface/popup'
import { TPopupHorizontal, TPopupVertical } from 'core-components/library/popup/interface/position'

export const PopupPositionContext = createContext<IPopupContentData>({
  direction: { horizontal: TPopupHorizontal.Right, vertical: TPopupVertical.Bottom },
  startPosition: { horizontal: TPopupHorizontal.Left, vertical: TPopupVertical.Top },
  action: {
    close: () => undefined,
    focus: () => undefined,
  },
})
